import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import {PricesBarChart} from "../components/prices_bar_chart/PricesBarChart";
import {PricesBigDataReferral} from "../components/PricesBigDataReferral";
import {PricesGeneralArticles} from "../components/PricesGeneralArticles";
import {PricesGeneralFAQ} from "../components/PricesGeneralFAQ";
import {PricesHeader} from "../components/PricesHeader";
import {PricesLinks} from "../components/PricesLinks";
import {PricesViewType} from "../helpers/prices_view_type";

export const PricesFlatsGeneralView = () => {
    return (
        <div>
            <PricesBreadcrumbs type={PricesViewType.FLATS} />

            <PricesHeader type={PricesViewType.FLATS} />

            <PricesBarChart type={PricesViewType.FLATS} />

            <PricesGeneralFAQ />

            <PricesGeneralArticles />

            <PricesLinks type={PricesViewType.FLATS} />

            <PricesBigDataReferral />
        </div>
    );
};
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import {PricesBarChart} from "../components/prices_bar_chart/PricesBarChart";
import {PricesBigDataReferral} from "../components/PricesBigDataReferral";
import {PricesGeneralArticles} from "../components/PricesGeneralArticles";
import {PricesGeneralFAQ} from "../components/PricesGeneralFAQ";
import {PricesHeader} from "../components/PricesHeader";
import {PricesLinks} from "../components/PricesLinks";
import {PricesViewType} from "../helpers/prices_view_type";

export const PricesFlatsGeneralView = () => {
    return (
        <div>
            <PricesBreadcrumbs type={PricesViewType.FLATS} />

            <PricesHeader type={PricesViewType.FLATS} />

            <PricesBarChart type={PricesViewType.FLATS} />

            <PricesGeneralFAQ />

            <PricesGeneralArticles />

            <PricesLinks type={PricesViewType.FLATS} />

            <PricesBigDataReferral />
        </div>
    );
};
